import React from 'react'
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined'
import { Chip } from '../Goals/Goals.styled'

type CampaignGoalChipProps = {
  campaignChipText: string
}

export const CampaignGoalChip = ({
  campaignChipText,
}: CampaignGoalChipProps) => (
  <Chip variant='informational'>
    <MonetizationOnOutlinedIcon />
    {campaignChipText}
  </Chip>
)
